import {
  AfterViewInit,
  Directive,
  EmbeddedViewRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { WhiteLabelService } from './services/whitelabel.service';

@Directive({
  selector: '[appIfWl]',
})
export class IfWlDirective implements OnDestroy, OnInit, AfterViewInit {
  private hasView = false;
  private view: EmbeddedViewRef<any>;

  private _appIfWl: boolean;
  @Input()
  set appIfWl(condition: boolean) {
    this._appIfWl = !!condition;
    this.set();
  }

  private _key: string;
  @Input()
  set appIfWlKey(key: string) {
    this._key = key;
  }

  private onDestroy = new Subject<void>();

  constructor(
    private renderer: Renderer2,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private whiteLabelService: WhiteLabelService,
  ) {}

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit() {
    this.whiteLabelService.isWhiteLabel
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => this.set());
  }

  ngAfterViewInit(): void {
    this.setAttribute();
  }

  set(): void {
    if (
      ((this._key && this.whiteLabelService.getI(this._key + '.hidden')) ||
        !this._appIfWl) &&
      this.hasView
    ) {
      this.viewContainer.clear();
      this.hasView = false;
      this.view = undefined;
    } else if (!this.hasView) {
      this.view = this.viewContainer.createEmbeddedView(this.templateRef);
      this.setAttribute();
      this.hasView = true;
    }
  }

  setAttribute(): void {
    if (!this.view || !this._key) return;

    let rootElem = this.view.rootNodes[0];

    if (rootElem) {
      if (rootElem.setAttribute) {
        this.renderer.setAttribute(rootElem, 'data-wl-key', this._key);
      } else {
        for (const childElem of (this.viewContainer.get(0) as any)?.rootNodes) {
          if (!childElem.setAttribute) continue;
          this.renderer.setAttribute(childElem, 'data-wl-key', this._key);
        }
      }
    }
  }
}
